<template>
  <SoWidget title="Meter Readings" data-testid="readings-widget">
    <SoButton
      title="Submit Readings"
      prepend-icon="upload"
      type="success"
      class="mt-2"
      data-testid="readings-submit-btn"
      @click="submitReading()"
    />
    <div class="my-3 gap-2">
      <div class="mb-3">
        <SoButton
          v-if="hasSmartMeter"
          title="Fetch Smart Readings"
          data-testid="readings-fetch-btn"
          @click="fetchSmartReadings()"
        />
      </div>
      <div class="mb-3">
        <SoButton
          title="Readings History"
          data-testid="readings-history-btn"
          @click="openReadingsHistory()"
        />
      </div>
      <div class="mb-3">
        <SoButton
          title="Meter Photos"
          data-testid="photo-history-btn"
          @click="isPhotoHistoryModalOpen = true"
        />
      </div>
      <div v-if="isEstimatorEnabled" class="mb-3">
        <SoButton
          title="Estimate Reads"
          data-testid="estimate-reads-btn"
          @click="isEstimateReadsModalOpen = true"
        />
      </div>
    </div>
  </SoWidget>
  <SubmitReadingsModal v-model="isSubmitReadingModalOpen" />
  <ReadingHistoryModal v-model="isReadingHistoryModalOpen" />
  <PhotoHistoryModal v-model="isPhotoHistoryModalOpen" />
  <FetchSmartReadsModal v-model="isFetchSmartReadsModalOpen" />
  <EstimateReadsModal
    v-if="isEstimatorEnabled"
    v-model="isEstimateReadsModalOpen"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointService } from "@/services/MeterpointService"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SubmitReadingsModal from "../modals/SubmitReadingsModal.vue"
  import FetchSmartReadsModal from "../modals/FetchSmartReadsModal.vue"
  import ReadingHistoryModal from "../modals/ReadingHistoryModal.vue"
  import PhotoHistoryModal from "../modals/PhotoHistoryModal.vue"
  import EstimateReadsModal from "../modals/EstimateReadsModal.vue"
  import { FeaturesService } from "@/services/admin/FeaturesService"
  import { METER_READ_ESTIMATOR_UI_FLAG } from "../components/EstimateReads/estimatorHelper"

  export default defineComponent({
    components: {
      SoWidget,
      SoButton,
      EstimateReadsModal,
      FetchSmartReadsModal,
      SubmitReadingsModal,
      ReadingHistoryModal,
      PhotoHistoryModal,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService: MeterpointService,
        isSubmitReadingModalOpen: false,
        isFetchSmartReadsModalOpen: false,
        isReadingHistoryModalOpen: false,
        isPhotoHistoryModalOpen: false,
        isEstimateReadsModalOpen: false,
      }
    },
    computed: {
      isEstimatorEnabled() {
        return (
          FeaturesService.isFeatureActive(METER_READ_ESTIMATOR_UI_FLAG) ?? false
        )
      },
      hasSmartMeter() {
        return this.current.meterpoints.data.some(
          (meterpoint) => meterpoint.hasSmartMeter,
        )
      },
    },
    created() {
      if (this.$route.query.openPhotoHistoryModal) {
        this.isPhotoHistoryModalOpen = true
      }
    },
    methods: {
      submitReading() {
        this.isSubmitReadingModalOpen = true
      },
      fetchSmartReadings() {
        this.isFetchSmartReadsModalOpen = true
      },
      openReadingsHistory() {
        this.isReadingHistoryModalOpen = true
      },
    },
  })
</script>
